import React from "react";
import { Field, reduxForm } from "redux-form";

class LoSentimosForm extends React.Component{

	salir = () => {
		this.props.change("acepto", false);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: false }))();
	}
	
	regresar = () => {
		this.props.change("acepto", true);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: true }))();
	}
	
	render() {
		const { handleSubmit, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className="text-content datos-wrap no-margin">
					<div className="row">
						<div className="col" style={{"textAlign": "center", "paddingTop":"10px"}}>
							<h3>Lo sentimos</h3>
						</div>
					</div>
					<div className="row">
						<div className="col" style={{"textAlign": "center"}}>
							<img src={require("../img/vector_fail.png")} />
						</div>
					</div>
					<div className="row">
						<div className="col" style={{"textAlign": "center"}}>
							<p>Al no aceptar el Contrato de Medios Electrónicos<br/>no es posible teminar tu registro.</p>
						</div>
					</div>
					<div className="row">
						<div className="col" style={{"textAlign": "center"}}>
							<span onClick={this.regresar} className="btn txt-orange">Regresar</span>
							<span onClick={this.salir} className="btn">Salir</span>
						</div>
					</div>
				</div>
				<Field name="acepto" component="input" type="hidden" />
			</form>
		);
	}
}

export default LoSentimosForm = reduxForm({form: "lo-sentimos"})(LoSentimosForm);


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/lo-sentimos.frm.js